import React from "react";
import tw from "twin.macro";

const BuyNowButton = tw.a`
  inline-block
  bg-yellow-400
  hover:bg-yellow-500
  text-black
  font-semibold
  text-lg
  px-6
  py-3
  rounded
  shadow
  transition
  duration-300
  ease-in-out
`;

const BuyNow = ({ link = "#target-section" }) => {
  return (
    <BuyNowButton href={link}>
      Buy Tickets Now
    </BuyNowButton>
  );
};

export default BuyNow;